import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { APP_ROUTES } from '../config/api.config';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  padding: 20px;
`;

const SuccessCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.5s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Icon = styled.div`
  color: #ff6b6b;
  font-size: 64px;
  margin-bottom: 24px;
  animation: scaleIn 0.5s ease-out;

  @keyframes scaleIn {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }
`;

const Title = styled.h1`
  color: #1a1a1a;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
`;

const Subtitle = styled.h2`
  color: #4b5563;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
`;

const Message = styled.p`
  color: #6b7280;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 32px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 16px;
`;

const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  padding: 12px 32px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  
  ${props => props.variant === 'primary' ? `
    background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
    color: white;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
    }
  ` : `
    background: white;
    color: #ff6b6b;
    border: 2px solid #ff6b6b;
    &:hover {
      background: rgba(255, 107, 107, 0.1);
    }
  `}
`;

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate(APP_ROUTES.DASHBOARD);
  };

  return (
    <PageContainer>
      <SuccessCard>
        <Icon>
          <FontAwesomeIcon icon={faCheckCircle} />
        </Icon>
        <Title>Payment Successful!</Title>
        <Subtitle>Thank you for your subscription</Subtitle>
        <Message>
          Your payment has been processed successfully. You can now access all the features of your subscription.
          We have sent the payment confirmation to your email address.
        </Message>
        <ButtonGroup>
          <Button variant="primary" onClick={handleBackToHome}>
            Back to Home
          </Button>
        </ButtonGroup>
      </SuccessCard>
    </PageContainer>
  );
};

export default PaymentSuccess; 